import React from "react";
import ChatQuestionRow from "./ChatQuestionRow";
import { useCurrentConversationQuestions } from "./hooks";
import LightTheme from "../theme/LightTheme";

const SessionQuestions = () => {
  const questions = useCurrentConversationQuestions();

  if (questions.length === 0) {
    return null;
  }

  return (
    <div className="presenterChatMain">
      <div className="questionsHeader">
        <div className="questionsBtn">
          <span>Session Questions</span>
        </div>
      </div>
      <div className="scroller">
        <div>
          {questions.map((question) => (
            <ChatQuestionRow question={question} key={question._id} />
          ))}
        </div>
      </div>
      <style jsx>
        {`
          span {
            font-weight: bold;
            color: ${LightTheme.font.secondary.color};
          }
          .presenterChatMain {
            display: flex;
            flex-direction: column;
            overflow: hidden;
            padding: 0 0 0 10px;
            border-bottom: solid 1px black;
            width: 100%;
          }
          .questionsHeader {
            display: flex;
            flex: 0 1 auto;
            justify-content: center;
            align-items: center;
            padding: 0 0 10px 0;
          }
          .questionsBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px 0 0 0;
            flex-direction: column;
          }
          .scroller {
            overflow-y: auto;
            overflow-x: hidden;
            flex: 1 1 auto;
          }
        `}
      </style>
    </div>
  );
};

export default SessionQuestions;
